import { FiLock } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/Button/Button";

const ChangePasswordSection = () => {
  const navigate = useNavigate();

  return (
    <div className="rounded-lg border border-gray-100 bg-white p-5 shadow-sm">
      <h2 className="text-sm font-semibold tracking-tight text-gray-900">
        Change Password
      </h2>
      <p className="mb-4 mt-0.5 text-xs text-gray-500">
        Choose a new password for your account. It must meet the portal's
        password requirements.
      </p>

      <Button size="sm" icon={FiLock} onClick={() => navigate("/change-password")}>
        Change Password
      </Button>
    </div>
  );
};

export default ChangePasswordSection;
